import React, { useState } from "react";
import ColorsMain from "../../colors/ColorsMain";
const ButtonCheckBox = ({ label, onClick, status, error = true }) => {


  const handleCheckboxChange = () => {
    onClick()
  };

  return (
    <div
      className={`flex items-center gap-3 p-4 cursor-pointer rounded-2xl bg-[${ColorsMain.bgDiv}] backdrop-blur-lg border ${status ? "border border-white" : "border border-transparent"
        }`}

      onClick={handleCheckboxChange} // Añadido onClick aquí
    >


      <label
        onClick={handleCheckboxChange}
        htmlFor={label}
        className={`w-5 h-5 flex items-center justify-center rounded-md cursor-pointer ${status ? "bg-[#5E5E63]" : "bg-[#1B1B22]"
          }`}
      >
        {status && (
          <svg
            onClick={handleCheckboxChange}
            xmlns="http://www.w3.org/2000/svg"
            className={`w-4 h-4 text-['${ColorsMain.errorBorder}'] `}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <polyline points="20 6 9 17 4 12" />
          </svg>
        )}
      </label>


      <span className={`text-[${ColorsMain.texttMain}]`}>{label}</span>
    </div>
  );
};

export default ButtonCheckBox;
